module.exports = "/assets/8a2cba6f6a161ad97c6f18327b0bc76c.png";